import React, { useMemo, useCallback, useEffect, memo } from 'react'
import { keys, size } from 'lodash'

import { syncAgGridSelection } from '../utils/table'

const HeaderCellCheckbox = ({
  api,
  column,
  selection,
  detailsSelection,
  onChangeSelectAllCallback
}) => {
  const {
    colDef: { detailField = null, rowId = '' }
  } = column
  const { context } = api.gridOptionsWrapper.gridOptions

  const {
    included = {},
    excluded = {},
    selectAll = false,
    selectable
  } = useMemo(
    () => (!rowId || !detailField ? selection : detailsSelection),
    [rowId, detailField, selection, detailsSelection]
  )

  const onPaginationChanged = useCallback(
    ({ keepRenderedRows }) => {
      if (keepRenderedRows) {
        api.forEachNode((node) => {
          if (selectAll && excluded[node.id]) {
            return
          }

          if (!selectAll && !included[node.id]) {
            return
          }

          syncAgGridSelection(true, { context, node, rowId, detailField })
        })
      }
    },
    [selectAll, detailField, rowId, context, excluded]
  )

  useEffect(() => {
    api.addEventListener('paginationChanged', onPaginationChanged)

    return () => {
      api.removeEventListener('paginationChanged', onPaginationChanged)
    }
  }, [onPaginationChanged])

  const onChangeSelectAll = () => {
    const newSelectAll = !selectAll

    api.forEachNode((node) => {
      syncAgGridSelection(newSelectAll, { context, node, rowId, detailField })
    })

    onChangeSelectAllCallback(newSelectAll)
  }

  const selectionClasses = useMemo(() => {
    const classes = 'ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper'

    if (selectable === 0) {
      return `${classes} hide-selectall-checkbox`
    }

    if (size(keys(excluded)) > 0 || size(keys(included)) > 0) {
      return `${classes} ag-indeterminate`
    }

    if (!selectAll) {
      return classes
    }

    return `${classes} ag-checked`
  }, [included, excluded, selectAll, selectable])

  return (
    <div className='ag-selection-checkbox' onClick={onChangeSelectAll}>
      <div className={selectionClasses}>
        <input
          id='custom-select-all'
          type='checkbox'
          aria-label='Toggle Row Selection'
          className='ag-input-field-input ag-checkbox-input'
        />
      </div>
    </div>
  )
}

export default memo(HeaderCellCheckbox)
